import { prismadb } from '@bareun/db';

export const getUserById = async (id: string) => {
  return await prismadb.user.findUnique({
    where: {
      id
    },
    include: {
      adminRole: true
    }
  });
};
